import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-701f0db0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MMultiSelect p-input-filled field" }

import MultiSelect from "primevue/multiselect"
  import { computed, Ref, withDefaults } from "vue"
  import { EntidadeGenerica } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  type EmitirModel = {
    (event: "update:modelValue", modelValue: string[] | Ref<string[]>): void
  }

  interface Props {
    placeholder?: string
    mensagemDeErro?: string | Ref<string>
    modelValue: string[] | Ref<string[]>
    optionLabel: string
    optionValue?: string
    options: EntidadeGenerica[]
    filtro?: boolean
    carregando?: boolean
    filtroPlaceholder?: string
    desativado?: boolean
    maximoDeLegendasSelecionadas?: number
    exibicaoDeOpcoes?: "comma" | "chip"
    dataTestid?: string
    teleportarPara?: string
    width?: string
    zIndex?: string
    obrigatorio?: boolean
    legendaMaximoSelecionados?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MMultiSelect',
  props: {
    placeholder: null,
    mensagemDeErro: null,
    modelValue: null,
    optionLabel: null,
    optionValue: null,
    options: null,
    filtro: { type: Boolean, default: true },
    carregando: { type: Boolean },
    filtroPlaceholder: { default: "" },
    desativado: { type: Boolean },
    maximoDeLegendasSelecionadas: null,
    exibicaoDeOpcoes: null,
    dataTestid: { default: "MMultiSelect" },
    teleportarPara: { default: "body" },
    width: null,
    zIndex: { default: "9999!important" },
    obrigatorio: { type: Boolean },
    legendaMaximoSelecionados: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:modelValue", modelValue: string[] | Ref<string[]>): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { placeholder?: string, mensagemDeErro?: string | Ref<string>, modelValue: string[] | Ref<string[]>, optionLabel: string, optionValue?: string, options: EntidadeGenerica[], filtro: boolean, carregando?: boolean, filtroPlaceholder: string, desativado?: boolean, maximoDeLegendasSelecionadas?: number, exibicaoDeOpcoes?: "comma" | "chip", dataTestid: string, teleportarPara: string, width?: string, zIndex: string, obrigatorio?: boolean, legendaMaximoSelecionados: string }

  const { t } = useI18n()

  

  const filtroPlaceholder = props.filtroPlaceholder || t("buscarPorNome")
  const legendaMaximoSelecionados = props.legendaMaximoSelecionados || `{0;} ${t("itensSelecionados")}`

  

  const ESTILO_PADRAO_DOS_ITENS_SELECIONADOS = "chip"
  const QUANTIDADE_MAXIMA_DE_ITENS_SELECIONADOS_PARA_EXIBICAO = 2

  const exibicaoDeOpcoesPadrao =
    props.exibicaoDeOpcoes || ESTILO_PADRAO_DOS_ITENS_SELECIONADOS
  const maximoDeLegendasSelecionadasPadrao =
    props.maximoDeLegendasSelecionadas ||
    QUANTIDADE_MAXIMA_DE_ITENS_SELECIONADOS_PARA_EXIBICAO

  const emitirModel = computed({
    get() {
      return props.modelValue
    },
    set(value: string[] | Ref<string[]>) {
      emitir("update:modelValue", value)
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MultiSelect), _mergeProps({
      modelValue: _unref(emitirModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null))
    }, _ctx.$attrs, {
      class: { 'p-invalid': __props.mensagemDeErro },
      "data-key": __props.optionValue || __props.optionLabel,
      "data-testid": __props.dataTestid,
      disabled: __props.desativado || __props.carregando,
      display: _unref(exibicaoDeOpcoesPadrao),
      filter: __props.filtro,
      "filter-placeholder": _unref(filtroPlaceholder),
      loading: __props.carregando,
      "max-selected-labels": _unref(maximoDeLegendasSelecionadasPadrao),
      "option-label": __props.optionLabel,
      "option-value": __props.optionValue,
      options: __props.options,
      "panel-style": { width: __props.width, zIndex: __props.zIndex },
      placeholder: __props.placeholder,
      required: __props.obrigatorio,
      "selected-items-label": _unref(legendaMaximoSelecionados)
    }), null, 16, ["modelValue", "class", "data-key", "data-testid", "disabled", "display", "filter", "filter-placeholder", "loading", "max-selected-labels", "option-label", "option-value", "options", "panel-style", "placeholder", "required", "selected-items-label"]),
    _withDirectives(_createElementVNode("small", {
      id: "input-help",
      class: "p-error",
      "data-testid": "input-error"
    }, _toDisplayString(__props.mensagemDeErro), 513), [
      [_vShow, __props.mensagemDeErro]
    ])
  ]))
}
}

})